export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NewsListing.vue?vue&type=template&id=98876ec4&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/NewsListing.vue?vue&type=template&id=98876ec4&scoped=true&
// module id = 307
// module chunks = 0